function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Rect, Circle, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Rect, {
  width: 49.45,
  height: 49.45,
  x: 0.275,
  y: 0.275,
  rx: 10,
  fill: "#00215A",
  stroke: "#7057FF",
  strokeWidth: 0.55
}), /*#__PURE__*/React.createElement(G, {
  stroke: "#00c080",
  strokeWidth: 0.907
}, /*#__PURE__*/React.createElement(G, {
  transform: "translate(17.557 12)"
}, /*#__PURE__*/React.createElement(Rect, {
  width: 14.887,
  height: 14.811,
  rx: 7.406
}), /*#__PURE__*/React.createElement(G, {
  transform: "translate(3.703 3.627)"
}, /*#__PURE__*/React.createElement(Circle, {
  cx: 3.778,
  cy: 3.778,
  r: 3.778
}), /*#__PURE__*/React.createElement(Circle, {
  cx: 3.778,
  cy: 3.778,
  r: 1.511
}))), /*#__PURE__*/React.createElement(Path, {
  d: "M17.557 31.874h14.887v1.965H17.557z"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M32.443 19.028h.34c1.023 0 1.852.829 1.852 1.851v12.96h0-2.192V19.028zm-14.886 0h-.34a1.852 1.852 0 00-1.852 1.851v12.96h2.192V19.028zm-5.252 14.811h25.39A2.305 2.305 0 0140 36.144v.717h0-30v-.717a2.305 2.305 0 012.305-2.305z"
})));

function SvgIconUpdateCamera(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), _ref);
}

export default SvgIconUpdateCamera;